<template>
  <div>
    <h1>Associar Usuários</h1>

    <div
      class="container-dados-perfil"
      v-if="!loadingUsuario && (listaDadosAssociados.length || listaDadosDisponiveis.length)"
    >
      <label>Perfil: {{ this.perfilSelecionado.name }}</label>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Usuários"
      tituloDisponiveis="Usuários"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="usuariosParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingUsuario" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PerfilUsuarioAssociacaoPage',

  data() {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created() {
    await this.listarUsuarios()
    await this.recuperarPerfilComUsuarios(this.$route.params.perfil)

    this.atualizarListaDeDadosAssociadosENaoAssociados()
  },

  computed: {
    ...mapGetters('perfisUsuarios', [
      'loadingUsuario',
      'listaDeUsuarios',
      'perfilSelecionadoComUsuarios'
    ]),

    perfilSelecionado() {
      return this.perfilSelecionadoComUsuarios
    },

    usuariosAssociados() {
      if (!this.perfilSelecionadoComUsuarios?.users) return []

      return this.perfilSelecionadoComUsuarios.users.map(usuario => ({
        id: usuario.id,
        descricao: usuario.name,
        selecionado: false
      }))
    },

    usuariosDisponiveis() {
      const associadosIds = this.perfilSelecionadoComUsuarios?.users?.map(u => u.id) || []
      const todosUsuarios = this.listaDeUsuarios?.data || []

      return todosUsuarios
        .filter(usuario => !associadosIds.includes(usuario.id))
        .map(usuario => ({
          id: usuario.id,
          descricao: usuario.name,
          selecionado: false
        }))
    }
  },

  methods: {
    ...mapActions('perfisUsuarios', [
      'listarUsuarios',
      'recuperarPerfilComUsuarios',
      'associarUsuariosAoPerfil'
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      this.listaDadosAssociados = this.usuariosAssociados
      this.listaDadosDisponiveis = this.usuariosDisponiveis
    },

    usuariosParaAssociar(value) {
      const listaIdsAssociados = value.listaAssociados.map(usuario => usuario.id)

      const payload = {
        usuarios: listaIdsAssociados,
        perfilId: this.$route.params.perfil
      }

      this.associarUsuariosAoPerfil(payload)
    }
  }
}
</script>

<style scoped>
.container-dados-perfil {
  margin-bottom: 20px;
}
</style>
